import type { AdminHostAgent } from '../types/admin';

export type HostLoadState = 'fresh' | 'stale' | 'waiting' | 'unavailable';

export function getHostLoadState(
  agent: Pick<AdminHostAgent, 'connection' | 'hostLoad'>,
  nowMs = Date.now(),
): HostLoadState {
  if (!agent.hostLoad) return agent.connection.connected ? 'waiting' : 'unavailable';
  const staleAfter = Date.parse(agent.hostLoad.staleAfter);
  if (!agent.connection.connected || !Number.isFinite(staleAfter) || staleAfter <= nowMs) {
    return 'stale';
  }
  return 'fresh';
}

export function formatHostLoadBytes(value: number): string {
  if (!Number.isFinite(value) || value < 0) return 'Unavailable';
  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];
  let amount = value;
  let unit = 0;
  while (amount >= 1024 && unit < units.length - 1) {
    amount /= 1024;
    unit += 1;
  }
  const decimals = amount >= 10 || unit === 0 ? 1 : 2;
  return `${amount.toFixed(decimals)} ${units[unit]}`;
}
